import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {CharacterList} from "./CharacterList";
import {Character} from "./Character";
import {Switch,Route} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    
}));

export function CharacterContainer(){

    const classes = useStyles();

    return (
        <Switch>
            <Route exact path={"/characters"} component={CharacterList} />
            <Route path={"/characters/:id"} component={Character} />
        </Switch>
    )
}